import { createAction } from '@reduxjs/toolkit';

import { actionType } from './actionType';

export const redirectTo = createAction(actionType.REDIRECT);
